export default __webpack_public_path__ + "static/media/about_guru.9282b9d8.jpg";